import React from 'react';
import { ChevronLeft16Regular, ChevronRight16Regular } from '@fluentui/react-icons';
import { pageDataService } from 'common/utilities';

export const BackIcon = () => (pageDataService.isRtlLocale() ? <ChevronRight16Regular /> : <ChevronLeft16Regular />);
